import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Toastiy from "../../../components/universal/Toastiy";
import {
  deleteCategoriesAction,
  deleteCategoriesRelatedAction,
  readCategoriesAction,
  readVideosAction,
  saveCategoriesAction,
  saveCategoriesIconAction,
  saveCategoriesRelatedAction,
  saveCategoryPreviewAction,
  saveCommonThumbnailCategoriesAction,
  saveLanguageCategoriesAction,
  translateLanguageAction,
  updateCategoriesAction,
  updateCategoriesIconAction,
  updateCategoriesRelatedAction,
  updateCategoryPreviewAction,
  updateCommonThumbnailCategoriesAction,
  updateLanguageCategoriesAction,
  uploadAssestsV2Action,
  uploadVideosV2Action,
} from "../../../store/Languages/LanguageAction";
import {
  deleteCategoryLayoutAction,
  readCategoryLayoutAction,
  saveCategoryLayoutAction,
  updateCategoryLayoutAction,
} from "../../../store/Layout/LayoutAction";

const initialCategoryValues = {
  _id: "",
  churchObjId: "",
  category_name: "",
  category_description: "",
  mobileUploadUrl: "",
  tabletUploadUrl: "",
  webUploadUrl: "",
  commonMobileUploadUrl: "",
  commonTabletUploadUrl: "",
  commonWebUploadUrl: "",
  mobilePreviewUrl: "",
  tabletPreviewUrl: "",
  webPreviewUrl: "",
};

const initialLayoutValues = {
  _id: "",
  layout_name: "",
  order: "",
};

export const CategoriesHooks = () => {
  const [value, setValue] = useState("");
  const onChangeSearchBar = (e) => setValue(e.target.value);
  return { value, onChangeSearchBar };
};

export const AllCategoriesHooks = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [reloadData, setReloadData] = useState(false);

  const onChangeSearchBar = (e) => setValue(e.target.value);

  const fetchAllCategories = (page, limit, searchCriteria = {}, callbackFn) => {
    dispatch(
      readCategoriesAction({
        apiPayloadRequest: {
          page,
          limit,
          searchCriteria,
        },
        callback: (res) => {
          if (!callbackFn) return;
          if (res?.type === 1) {
            callbackFn({
              data: (res?.data ?? []).map((item) => ({
                ...item,
                category_views: item?.category_views ?? 0,
              })),
              total: res?.totalRecords ?? 0,
            });
            return;
          }
          callbackFn({ data: [], total: res?.totalRecords ?? 0 });
        },
      })
    );
  };

  const handleDelete = (row) => {
    if (!row?._id) return;
    dispatch(
      deleteCategoriesAction({
        apiPayloadRequest: { _id: row._id },
        callback: (res) => {
          if (res?.type === 1) {
            Toastiy("Category Deleted Successfully!", 1);
            setReloadData(true);
            return;
          }
          Toastiy("Failed to delete category");
        },
      })
    );
  };

  return {
    value,
    onChangeSearchBar,
    handleDelete,
    handleEyeClick: () => {},
    fetchAllCategories,
    reloadData,
    setReloadData,
  };
};

export const AddCategoriesHooks = (data = {}, options = [], setLoading = () => {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  void options;

  const [value, setValue] = useState("");
  const [activeTab, setActiveTab] = useState("en");
  const [activeLanguageDetails, setActiveLanguageDetails] = useState({
    language_code: "en",
    language_name: "English",
  });
  const [categoryInputs, setCategoryInputs] = useState(initialCategoryValues);
  const [translateCategories, setTranslateCategories] = useState({
    category_name: "",
    category_description: "",
  });
  const [categoryErrors, setCategoryErrors] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedRelatedVideoIndex, setSelectedRelatedVideoIndex] = useState(null);
  const [showVideoLibraryModal, setShowVideoLibraryModal] = useState(false);
  const [layoutValues, setLayoutValues] = useState(initialLayoutValues);
  const [layoutInfo, setLayoutInfo] = useState(false);
  const [layoutArray, setLayoutArray] = useState([]);
  const [addedLayout, setAddedLayout] = useState(false);
  const [isLayoutEdit, setIsLayoutEdit] = useState(false);
  const [editLayoutIndex, setEditLayoutIndex] = useState(null);
  const [editTargetLayout, setEditTargetLayout] = useState("");
  const [languagemeta, setLanguagemeta] = useState([]);
  const [isLanguageSave, setIsLanguageSave] = useState(true);
  const [categoryStats, setCategoryStats] = useState({
    totalLikes: 0,
    totalViews: 0,
  });

  const categoryId = categoryInputs?._id || data?._id || "";

  const onChangeSearchBar = (e) => setValue(e.target.value);

  const handleInputChange = (event) => {
    const { name, value: inputValue } = event.target;
    setCategoryInputs((prev) => ({ ...prev, [name]: inputValue }));
    setCategoryErrors((prev) => ({ ...prev, [name]: false }));
  };

  const uploadAndSetUrl = (event, action, errorKeyName, uploadProgressId) => {
    const file = event?.target?.files?.[0];
    const keyName = event?.target?.name;
    if (!file || !keyName) return;

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    dispatch(
      action({
        apiPayloadRequest: formData,
        uploadProgressId,
        callback: (res) => {
          setLoading(false);
          const uploadedUrl = res?.url || res?.data?.url || "";
          if (!uploadedUrl) {
            Toastiy("Upload failed");
            return;
          }
          setCategoryInputs((prev) => ({ ...prev, [keyName]: uploadedUrl }));
          if (errorKeyName) {
            setCategoryErrors((prev) => ({ ...prev, [errorKeyName]: false }));
          }
        },
      })
    );
  };

  const handleUploadInput = (event, errorKeyName, uploadProgressId = null) =>
    uploadAndSetUrl(event, uploadAssestsV2Action, errorKeyName, uploadProgressId);

  const handleUploadVideo = (event, errorKeyName, uploadProgressId = null) =>
    uploadAndSetUrl(event, uploadVideosV2Action, errorKeyName, uploadProgressId);

  const handleDropdownChange = (videoItem) => {
    if (!videoItem?.value) return;

    const itemToSet = {
      ...videoItem,
      order: videoItem?.order || `${selectedOptions?.length + 1}`,
    };

    if (categoryId) {
      dispatch(
        saveCategoriesRelatedAction({
          apiPayloadRequest: {
            _id: categoryId,
            videoObjId: itemToSet.value,
            order: itemToSet.order,
          },
          callback: (res) => {
            if (res?.type !== 1) {
              Toastiy("Failed to add related video");
              return;
            }
            setSelectedOptions((prev) => {
              if (selectedRelatedVideoIndex !== null) {
                return prev.map((item, index) =>
                  index === selectedRelatedVideoIndex ? itemToSet : item
                );
              }
              return [...prev, itemToSet];
            });
            setShowVideoLibraryModal(false);
            setSelectedRelatedVideoIndex(null);
            setCategoryErrors((prev) => ({ ...prev, selectedOptions: false }));
          },
        })
      );
      return;
    }

    setSelectedOptions((prev) => {
      if (selectedRelatedVideoIndex !== null) {
        return prev.map((item, index) => (index === selectedRelatedVideoIndex ? itemToSet : item));
      }
      return [...prev, itemToSet];
    });
    setShowVideoLibraryModal(false);
    setSelectedRelatedVideoIndex(null);
    setCategoryErrors((prev) => ({ ...prev, selectedOptions: false }));
  };

  const deleteRelatedVideo = (videoObjId) => {
    if (!videoObjId) return;
    if (!categoryId) {
      setSelectedOptions((prev) => prev.filter((item) => item?.value !== videoObjId));
      return;
    }
    dispatch(
      deleteCategoriesRelatedAction({
        apiPayloadRequest: { _id: categoryId, videoObjId },
        callback: (res) => {
          if (res?.type === 1) {
            setSelectedOptions((prev) => prev.filter((item) => item?.value !== videoObjId));
            Toastiy("Related Video Removed Successfully!", 1);
            return;
          }
          Toastiy("Failed to delete related video");
        },
      })
    );
  };

  const updateRelatedVideoOrder = (item) => {
    if (!item?.value || !item?.order) return;
    if (!categoryId) return;
    dispatch(
      updateCategoriesRelatedAction({
        apiPayloadRequest: {
          _id: categoryId,
          videoObjId: item.value,
          order: item.order,
        },
        callback: (res) => {
          if (res?.type !== 1) Toastiy("Failed to update related video order");
        },
      })
    );
  };

  const handleVideoLayoutChange = (e) => {
    const { name, value: inputValue } = e.target;
    setLayoutValues((prev) => ({ ...prev, [name]: inputValue }));
  };

  const handleCategoryLayoutChange = handleVideoLayoutChange;
  const handleDateChange = () => {};
  const handleVideoDateChange = () => {};

  const handleAddLayoutToArray = () => {
    if (!layoutValues?.layout_name || !layoutValues?.order) return;

    if (categoryId) {
      dispatch(
        saveCategoryLayoutAction({
          apiPayloadRequest: {
            _id: layoutValues?._id,
            categoryObjId: categoryId,
            order: layoutValues?.order,
          },
          callback: (res) => {
            if (res?.type === 1) {
              setLayoutArray((prev) => [...prev, layoutValues]);
              setLayoutValues(initialLayoutValues);
              setAddedLayout(true);
              return;
            }
            Toastiy("Failed to add layout");
          },
        })
      );
      return;
    }

    setLayoutArray((prev) => [...prev, layoutValues]);
    setLayoutValues(initialLayoutValues);
    setAddedLayout(true);
  };

  const handleDeleteLayoutFromArray = (id) => {
    if (!id) {
      setLayoutArray((prev) => prev.filter((item) => item?._id !== id));
      return;
    }
    if (categoryId) {
      dispatch(
        deleteCategoryLayoutAction({
          apiPayloadRequest: { _id: id, categoryObjId: categoryId },
          callback: (res) => {
            if (res?.type === 1) {
              setLayoutArray((prev) => prev.filter((item) => item?._id !== id));
              return;
            }
            Toastiy("Failed to delete layout");
          },
        })
      );
      return;
    }
    setLayoutArray((prev) => prev.filter((item) => item?._id !== id));
  };

  const handleLayoutUpdate = () => {
    if (editLayoutIndex === null) return;

    if (categoryId) {
      dispatch(
        updateCategoryLayoutAction({
          apiPayloadRequest: {
            _id: layoutValues?._id,
            categoryObjId: categoryId,
            order: layoutValues?.order,
          },
          callback: (res) => {
            if (res?.type === 1) {
              setLayoutArray((prev) =>
                prev.map((item, index) => (index === editLayoutIndex ? layoutValues : item))
              );
              setIsLayoutEdit(false);
              setEditLayoutIndex(null);
              setLayoutValues(initialLayoutValues);
              return;
            }
            Toastiy("Failed to update layout");
          },
        })
      );
      return;
    }

    setLayoutArray((prev) => prev.map((item, index) => (index === editLayoutIndex ? layoutValues : item)));
    setIsLayoutEdit(false);
    setEditLayoutIndex(null);
    setLayoutValues(initialLayoutValues);
  };

  const validate = () => {
    const errors = {
      category_name: !categoryInputs?.category_name?.trim(),
      category_description: !categoryInputs?.category_description?.trim(),
    };
    const hasErrors = Object.values(errors).some(Boolean);
    setCategoryErrors((prev) => ({ ...prev, ...errors }));
    if (hasErrors) Toastiy("Category name and description are required");
    return !hasErrors;
  };

  const upsertUrlRecords = async (savedCategoryId, urlType) => {
    const urlKeyByType = {
      icon: ["mobileUploadUrl", "tabletUploadUrl", "webUploadUrl"],
      common: ["commonMobileUploadUrl", "commonTabletUploadUrl", "commonWebUploadUrl"],
      preview: ["mobilePreviewUrl", "tabletPreviewUrl", "webPreviewUrl"],
    };
    const actionByType = {
      icon: {
        save: saveCategoriesIconAction,
        update: updateCategoriesIconAction,
      },
      common: {
        save: saveCommonThumbnailCategoriesAction,
        update: updateCommonThumbnailCategoriesAction,
      },
      preview: {
        save: saveCategoryPreviewAction,
        update: updateCategoryPreviewAction,
      },
    };

    const keys = urlKeyByType[urlType] || [];
    const actions = actionByType[urlType];
    const records = keys
      .map((key, index) => ({
        type_of_url: `${index}`,
        url_link: categoryInputs?.[key] || "",
      }))
      .filter((item) => !!item.url_link);

    for (const record of records) {
      await new Promise((resolve) => {
        dispatch(
          (data?._id ? actions.update : actions.save)({
            apiPayloadRequest: {
              _id: savedCategoryId,
              type_of_url: record.type_of_url,
              url_link: record.url_link,
            },
            callback: () => resolve(),
          })
        );
      });
    }
  };

  const handleSave = async (hideUI = false, onClose = null, churchObjId = "") => {
    if (!validate()) return;

    setLoading(true);
    const payload = {
      _id: categoryId,
      churchObjId: categoryInputs?.churchObjId || churchObjId || undefined,
      category_name: categoryInputs?.category_name?.trim(),
      category_description: categoryInputs?.category_description?.trim(),
    };

    const action = categoryId ? updateCategoriesAction : saveCategoriesAction;

    dispatch(
      action({
        apiPayloadRequest: payload,
        callback: async (res) => {
          if (res?.type !== 1) {
            setLoading(false);
            Toastiy("Failed to save category");
            return;
          }

          const savedCategoryId = res?.data?.[0]?._id || categoryId;
          setCategoryInputs((prev) => ({ ...prev, _id: savedCategoryId }));

          await upsertUrlRecords(savedCategoryId, "icon");
          await upsertUrlRecords(savedCategoryId, "common");
          await upsertUrlRecords(savedCategoryId, "preview");

          setLoading(false);
          Toastiy(categoryId ? "Category Updated Successfully!" : "Category Saved Successfully!", 1);

          if (hideUI && onClose) {
            onClose();
            return;
          }
          if (!hideUI) navigate("/categories/all");
        },
      })
    );
  };

  const handleSaveLanguage = () => {
    if (!categoryId || activeTab === "en") return;
    const action = isLanguageSave ? saveLanguageCategoriesAction : updateLanguageCategoriesAction;
    dispatch(
      action({
        apiPayloadRequest: {
          _id: categoryId,
          categoryObjId: categoryId,
          languagecode: activeTab,
          category_name: categoryInputs?.category_name || "",
          category_description: categoryInputs?.category_description || "",
        },
        callback: (res) => {
          if (res?.type === 1) {
            setIsLanguageSave(false);
            Toastiy("Language data saved successfully", 1);
            return;
          }
          Toastiy("Failed to save language data");
        },
      })
    );
  };

  const updateStateWithTranslation = () => {
    const sourceTitle = translateCategories?.category_name || categoryInputs?.category_name || "";
    const sourceDescription =
      translateCategories?.category_description || categoryInputs?.category_description || "";
    const text = `${sourceTitle}///${sourceDescription}`;
    dispatch(
      translateLanguageAction({
        apiPayloadRequest: {
          targetcode: activeTab,
          translatetext: text,
        },
        callback: (res) => {
          if (res?.type !== 1) return;
          const [translatedTitle = "", translatedDescription = ""] = (res?.data || "").split("///");
          setCategoryInputs((prev) => ({
            ...prev,
            category_name: translatedTitle,
            category_description: translatedDescription,
          }));
        },
      })
    );
  };

  const handleSendNotification = () => {
    Toastiy("Notification flow not configured for categories yet.");
  };

  useEffect(() => {
    if (!data?._id) return;
    setLoading(true);
    dispatch(
      readCategoriesAction({
        apiPayloadRequest: { _id: data._id },
        callback: (res) => {
          setLoading(false);
          if (res?.type !== 1 || !res?.data?.length) return;
          const category = res.data[0];
          setCategoryInputs({
            _id: category?._id || "",
            churchObjId: category?.churchObjId || "",
            category_name: category?.category_name || "",
            category_description: category?.category_description || "",
            mobileUploadUrl:
              category?.icon_images?.find((u) => `${u?.type_of_url}` === "0")?.url_link || "",
            tabletUploadUrl:
              category?.icon_images?.find((u) => `${u?.type_of_url}` === "1")?.url_link || "",
            webUploadUrl:
              category?.icon_images?.find((u) => `${u?.type_of_url}` === "2")?.url_link || "",
            commonMobileUploadUrl:
              category?.gnerictumbnailurls?.find((u) => `${u?.type_of_url}` === "0")?.url_link || "",
            commonTabletUploadUrl:
              category?.gnerictumbnailurls?.find((u) => `${u?.type_of_url}` === "1")?.url_link || "",
            commonWebUploadUrl:
              category?.gnerictumbnailurls?.find((u) => `${u?.type_of_url}` === "2")?.url_link || "",
            mobilePreviewUrl:
              category?.trailervideos?.find((u) => `${u?.type_of_url}` === "0")?.url_link || "",
            tabletPreviewUrl:
              category?.trailervideos?.find((u) => `${u?.type_of_url}` === "1")?.url_link || "",
            webPreviewUrl:
              category?.trailervideos?.find((u) => `${u?.type_of_url}` === "2")?.url_link || "",
          });
          setTranslateCategories({
            category_name: category?.category_name || "",
            category_description: category?.category_description || "",
          });
          setLanguagemeta(category?.languagemetas || []);
          setCategoryStats({
            totalLikes: category?.totallikes ?? 0,
            totalViews: category?.category_views ?? 0,
          });
          const relatedVideos =
            category?.relatedvideos
              ?.filter((rv) => rv?.videoObjId?.length)
              ?.map((rv) => ({
                value: rv?.videoObjId?.[0]?._id || "",
                label: rv?.videoObjId?.[0]?.video_title || "",
                order: rv?.order || "",
                image:
                  rv?.videoObjId?.[0]?.tumbnailurls?.find((u) => `${u?.type_of_url}` === "0")
                    ?.url_link || "",
              })) || [];
          setSelectedOptions(relatedVideos);
        },
      })
    );
  }, [data?._id, dispatch, setLoading]);

  useEffect(() => {
    if (!categoryId) return;
    dispatch(
      readCategoryLayoutAction({
        apiPayloadRequest: { _id: categoryId, categoryObjId: categoryId },
        callback: (res) => {
          if (res?.type !== 1) return;
          setLayoutArray(res?.data || []);
        },
      })
    );
  }, [categoryId, dispatch]);

  return {
    value,
    onChangeSearchBar,
    languages: ["english", "hindi", "tamil"],
    activeTab,
    setActiveTab,
    inputs: {},
    handleInputChange,
    handleSave,
    categoryInputs,
    setCategoryInputs,
    categoryErrors,
    layoutValues,
    initialLayoutValues,
    selectedOptions,
    handleDropdownChange,
    setLayoutValues,
    handleCategoryLayoutChange,
    layoutInfo,
    setLayoutInfo,
    handleUploadInput,
    handleUploadVideo,
    handleDateChange,
    addedLayout,
    setAddedLayout,
    setLayoutArray,
    setIsLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    isLayoutEdit,
    editLayoutIndex,
    editTargetLayout,
    handleDeleteLayoutFromArray,
    handleLayoutUpdate,
    handleVideoLayoutChange,
    handleAddLayoutToArray,
    handleVideoDateChange,
    layoutArray,
    setIsLanguageSave,
    languagemeta,
    updateStateWithTranslation,
    handleSaveLanguage,
    activeLanguageDetails,
    setActiveLanguageDetails,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    deleteRelatedVideo,
    updateRelatedVideoOrder,
    setSelectedOptions,
    setSelectedRelatedVideoIndex,
    categoryStats,
    handleSendNotification,
    setTranslateCategories,
    setLanguagemeta,
    setCategoryStats,
  };
};

export const GetRelatedVideosHooks = () => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    dispatch(
      readVideosAction({
        apiPayloadRequest: { page: 1, limit: 300, searchCriteria: {} },
        callback: (res) => {
          if (res?.type !== 1) return;
          const videoOptions = (res?.data || []).map((item) => ({
            value: item?._id || "",
            label: item?.video_title || "",
            image: item?.tumbnailurls?.[0]?.url_link || "",
          }));
          setOptions(videoOptions);
        },
      })
    );
  }, [dispatch]);

  return { options };
};
